import { createFileRoute } from '@tanstack/react-router'
import { Nav } from '@/components/landing/nav'
import { Hero } from '@/components/landing/hero'
import { Signature } from '@/components/landing/signature'
import { Offer } from '@/components/landing/offer'
import { HowItWorks } from '@/components/landing/how-it-works'
import { WorkSection } from '@/components/landing/work-section'
import { Testimonials } from '@/components/landing/testimonials'
import { WhyVello } from '@/components/landing/why-vello'
import { FAQ } from '@/components/landing/faq'
import { FinalCTA } from '@/components/landing/final-cta'
import { Footer } from '@/components/landing/footer'
import { StickyMobileCTA } from '@/components/landing/sticky-mobile-cta'

export const Route = createFileRoute('/')({
  component: LandingPage,
  head: () => ({
    links: [{ rel: 'canonical', href: 'https://withvello.com/' }],
  }),
})

function LandingPage() {
  return (
    <div data-screen-label="Vello Landing">
      <Nav />
      <Hero />
      <Signature />
      <Offer />
      <HowItWorks />
      <WorkSection />
      <Testimonials />
      <WhyVello />
      <FAQ />
      <FinalCTA />
      <Footer />
      <StickyMobileCTA />
    </div>
  )
}
